import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  useTheme,
} from '@mui/material'
import { useTranslation } from 'react-i18next'

import { ModalWrapper } from 'src/components'

import { useStyles } from './../styles'
import { useGetDeclineReasonsOptions } from 'src/hooks/decline-reasons'
import { Dispatch, SetStateAction, useState } from 'react'
import {
  IConsumerScanDeclineReason,
  IConsumerScanRespDto,
  IDeclineReasonsBaseWithId,
  IItemsRemoveConfirmModalValues,
} from 'src/types'

interface IProps {
  open: boolean
  handleClose: () => void
  handleConfirmDecline: (reason: IConsumerScanDeclineReason) => void
  confirmModalHandler: Dispatch<SetStateAction<IItemsRemoveConfirmModalValues | null>>
  item: IConsumerScanRespDto
}

export const DeclineReasonModal = ({
  open,
  handleClose,
  handleConfirmDecline,
  confirmModalHandler,
  item,
}: IProps) => {
  const [t] = useTranslation()
  const classes = useStyles()
  const theme = useTheme()

  const [reason, setReason] = useState<IDeclineReasonsBaseWithId | null>(null)

  const { data } = useGetDeclineReasonsOptions()

  const handleReasonSelect = (reasonId: string) => {
    const item = data?.find((item) => item.id === reasonId)

    if (item) {
      setReason(item)
    }
  }

  const handleItemStatusDecline = async (item: IConsumerScanRespDto) => {
    if (!item) return

    confirmModalHandler({
      handleConfirm: async () => {
        if (reason) {
          handleConfirmDecline(reason)
        }
      },
      customModal: {
        title: 'Confirm Decline',
      },
      itemsTitles: [],
      itemsDetails: [
        { text: item.barcode_id, title: 'Barcode ID' },
        { text: item.product_name, title: 'Product Name' },
        { text: item.company_name, title: 'Account Name' },
        { text: reason?.reason_text || '', title: 'Reason' },
      ],
      itemsRelations: [],
      itemsType: '',
    })
  }

  return (
    <ModalWrapper
      open={open}
      onClose={() => {
        setReason(null)
        handleClose()
      }}
      className={classes.reasonModal}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',

          gap: '12px',
        }}
      >
        <Typography
          sx={{
            color: theme.palette.custom.darkBlue2,
            fontSize: '18px',
            fontWeight: 600,
            width: '100%',
          }}
        >
          Select decline reason:
        </Typography>

        {!!data && (
          <Select
            name="type"
            value={reason?.id || ''}
            onChange={(e) => handleReasonSelect(e.target.value)}
            size="small"
            autoWidth
            MenuProps={{ style: { maxHeight: '400px' } }}
            sx={{
              fontSize: '12px',
              // border: 'none',
              // boxShadow: 'none',
              // '& .MuiOutlinedInput-notchedOutline': { display: 'none' },
            }}
          >
            {data.map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {item.name}
              </MenuItem>
            ))}
          </Select>
        )}

        <Box>
          <Typography
            sx={{
              color: theme.palette.custom.darkBlue2,
              fontSize: '14px',
              width: '100%',
              fontWeight: 600,
            }}
          >
            Reason text:
          </Typography>
          {reason && (
            <Typography
              sx={{
                color: theme.palette.custom.darkBlue2,
                fontSize: '14px',
                width: '100%',
              }}
            >
              {reason.reason_text}
            </Typography>
          )}
        </Box>
      </Box>
      <Box sx={{ width: '100%', textAlign: 'center', pt: '10px' }}>
        <Button
          onClick={() => {
            handleItemStatusDecline(item)
            handleClose()
          }}
          variant="contained"
          size="small"
        >
          Confirm
        </Button>
      </Box>
    </ModalWrapper>
  )
}
